export function formatDuration(microseconds: number): string {
  if (!microseconds || microseconds <= 0) return '0s'

  // Convert microseconds to seconds first
  let seconds = Math.floor(microseconds / 1000000)

  const years = Math.floor(seconds / (365 * 24 * 60 * 60))
  seconds = seconds % (365 * 24 * 60 * 60)

  const months = Math.floor(seconds / (30 * 24 * 60 * 60))
  seconds = seconds % (30 * 24 * 60 * 60)

  const days = Math.floor(seconds / (24 * 60 * 60))
  seconds = seconds % (24 * 60 * 60)

  const hours = Math.floor(seconds / (60 * 60))
  seconds = seconds % (60 * 60)

  const minutes = Math.floor(seconds / 60)
  seconds = Math.floor(seconds % 60)

  const parts: string[] = []

  if (years > 0) parts.push(`${years}y`)
  if (months > 0) parts.push(`${months}m`)
  if (days > 0) parts.push(`${days}d`)
  if (hours > 0) parts.push(`${hours}h`)
  if (minutes > 0) parts.push(`${minutes}min`)
  if (seconds > 0 && parts.length === 0) parts.push(`${seconds}s`)

  // If no larger units and we have microseconds, show milliseconds or microseconds
  if (parts.length === 0) {
    const remainingMs = Math.floor(microseconds / 1000)
    if (remainingMs > 0) {
      return `${remainingMs}ms`
    }
    return `${microseconds}µs`
  }

  // Only show up to 2 most significant units
  return parts.slice(0, 2).join(' ')
}

export function formatResponseTime(nanoseconds: number): string {
  if (!nanoseconds || nanoseconds <= 0) return '0ms'

  // Convert to milliseconds for easier comparison
  const ms = nanoseconds / 1_000_000

  if (ms >= 1) {
    // If >= 1ms, show in milliseconds with one decimal place
    return `${ms.toFixed(1)}ms`
  }

  // Convert to microseconds for next comparison
  const microseconds = nanoseconds / 1000
  if (microseconds >= 1) {
    // If >= 1µs, show in microseconds with one decimal place
    return `${microseconds.toFixed(1)}µs`
  }

  // Show in nanoseconds for very small values
  return `${Math.floor(nanoseconds)}ns`
}
